// extracted by mini-css-extract-plugin
export default {"wrapper":"pd","form":"qd","checkbox":"rd","successWrapper":"sd","success":"td","successText":"ud","circle":"vd","footnote":"wd","required":"xd"};